import { createContext } from 'react';

export const notFoundContext = createContext<{
  /** Whether the current page is a 404 page. */
  is404Page: boolean;
  /** Set whether the current page is a 404 page. */
  setIs404Page: (is404Page: boolean) => void;
}>(null as any);
